export const MethodShipments = Object.freeze({
    Manual: "M",
    AutoSelect: "A",
    AutoDefault: "D",
    ShowList: "L",
    JulianDate: "J",
    Custom: "C"
});

export const LotPickMethodShipments = Object.freeze({
    LotCode: 'L',
    Description1: 'D',
    ClassCode: 'C',
    SubClassCode: 'S',
    DateIntroduced: 'I',
    DateAvailable: 'A',
    DateExpiration: 'E'
});

export const SublotPickMethodShipments = Object.freeze({
    SublotCode: 'S',
    Description1: 'D',
    DateIntroduced: 'I',
    DateAvailable: 'A',
    DateExpiration: 'E'
});

export const UnitPickMethodShipments = Object.freeze({
    UnitCode: 'U',
    DateIntroduced: 'I',
    DateAvailable: 'A',
    DateExpiration: 'E'
});

export const PickSequence = Object.freeze({
    Ascending: 'A',
    Descending: 'D'
});
export const PopulateLotWithCarrier = Object.freeze({
    PopulateCarrierIdAndScac: 'S',
    PopulateCarrierId: 'I',
    DoNotPopulateCarrier: 'N'

});
export const DefaultItemLotManagementUnit = Object.freeze({
    DefaultFromItemMasterRecord: 'I',
    DefaultFromTransactionHeaderRecord: 'T',
    ManualEntry: 'M'
});
export const SortDirectionOptions = [
    { id: "A", name: "Ascending" },
    { id: "D", name: "Descending" }
];
export const LocationPickMethodOptions = [
    { id: "L", name: "Location Code" },
    { id: "P", name: "Priority Code" },
    { id: "C", name: "Class Code" },
    { id: "S", name: "Sub Class Code" }
];
export const LotPickMethodOptions = [
    { id: 'L', name: "Lot Code" },
    { id: 'D', name: "Description - 1" },
    { id: 'C', name: "Class Code" },
    { id: 'S', name: "Sub Class Code" },
    { id: 'I', name: "Date Introduced" },
    { id: 'A', name: "Date Available" },
    { id: 'E', name: "Date Expiration" },
];
export const SublotPickMethodOptions = [
    { id: 'S', name: 'Sublot Code' },
    { id: 'D', name: 'Description - 1' },
    { id: 'I', name: 'Date Introduced' },
    { id: 'A', name: 'Date Available' },
    { id: 'E', name: 'Date Expiration' }
]

/**
 * OMTRANSACTIONDP.LOTCODEDEFAULTMETHOD — the OM "Pick Method" list. Shared by the Sales Order Profile
 * form (where the default is set) and the OMD0015 "Shipment" dialog (where it can be overridden for one
 * run), so the two can never drift apart.
 */
export const LotCodeDefaultMethodOptions = [
    { id: 'N', name: 'None' },
    { id: 'D', name: 'Date Introduced' },
    { id: 'A', name: 'Date Available' },
    { id: 'E', name: 'Date Expiration' },
    { id: 'Q', name: 'Available Quantity' },
    { id: 'L', name: 'Lot Code' },
    { id: 'C', name: 'Lot Code Between Avail & Expiration' }
];

/**
 * OMD0015 "Ship Quantity Basis". The codes are the ones SPOM_STAGECHANGE already takes for
 * @inUpdateShipQuantityMethod (uOMM0000.pas:3346), so web and legacy agree on the wire.
 */
export const ShipQuantityBasis = Object.freeze({
    /** Ship as Ordered - allocate against the ordered quantity. */
    Automatic: 'AUTO',
    /** Ship as Specified by User - allocate against the shipped quantity the user keyed. */
    Manual: 'MAN'
});

export const ShipQuantityBasisOptions = [
    { id: ShipQuantityBasis.Automatic, name: 'Ship as Ordered - Automatic' },
    { id: ShipQuantityBasis.Manual, name: 'Ship as Specified by User - Manual' }
];
